import type {
  AudienceRuleUserExport,
  FacebookAdsMetaStatus,
} from '@shared/api/rtkQuery'

export const checkIsNeedPollingExportInfo = (
  status?: AudienceRuleUserExport['status'],
  metaStatus?: FacebookAdsMetaStatus
) => {
  if (!status) {
    return false
  }

  if (status === 'initialized' || status === 'processing') {
    return true
  }

  if (status === 'completed' && metaStatus === 'meta_processing') {
    return true
  }

  return false
}
